export const FIELD_TYPES = {
	NUMBER: 'number',
	FLOAT: 'float'
}
